<template>
  <div>
    <AllOrders :selectedStatuses="statuses" :collectedOrder="true" />
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
const AllOrders = defineAsyncComponent(() =>
  import("@/components/orders/AllOrders")
);
export default {
  name: "CollectedSamplesOrders",
  components: {
    AllOrders,
  },
  data() {
    return {
      statuses: ["ACTIVE", "PARTIAL"],
    };
  },
};
</script>
